<template>
  <modal
    :modal-id="modalId"
    :title="modalTitle"
    :preloader="preloader"
    @submit="submit"
    @close-modal="closeModal"
  >
    <template slot="body">
      <app-overlay-loader v-if="preloader" />
      <form
        class="mb-0"
        :class="{ 'loading-opacity': preloader }"
        ref="form"
        :data-url="selectedUrl ? `${addurl}/${inputs.id}` : addurl"
      >
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label>{{ $t("title") }}</label>
              <app-input type="text" v-model="inputs.title"
              :required="true" />
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label>{{ $t("description") }}</label>
              <app-input
                type="textarea"
                id="textarea-id"
                :label="$t('message_placeholder')"
                v-model="inputs.description"
              />
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label>{{ $t("users") }}</label>
              <app-input
                type="multi-select"
                :placeholder="$t('select_user')"
                :list="this.users"
                v-model="inputs.select_users"
                :required="true"
              />
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12">
            <div class="form-group">
              <label>{{ $t("companies") }}</label>
              <app-input
                type="multi-select"
                :placeholder="$t('select_companies')"
                :list="this.companies"
                v-model="inputs.select_companies"
                :required="true"
              />
            </div>
          </div>
          <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="form-group">
              <label>{{ $t("status") }}</label>
              <app-input
                type="select"
                :list="this.status"
                v-model="inputs.status"
                :required="true"
              />
            </div>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";
import * as actions from "../../../../Config/ApiUrl";
import { axiosPost, axiosGet} from "../../../../../app/Helpers/AxiosHelper";

export default {
  name: "AddModal",
  mixins: [FormMixin, ModalMixin],
  props: {
    tableId: String,
  },
  data() {
    return {
      addurl:actions.WORKSPACE_STORE,
      preloader: false,
      inputs: {},
      status: [
        { id: "", value: "Choose One" },
        { id: "1", value: "Active" },
        { id: "0", value: "Inactive" },
      ],
      modalId: "demo-add-edit-Modal",
      modalTitle: this.$t("add"),
      users: [],
      companies: [],
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      // this.postUrl = actions.CERTIFICATE_CATEGORY_UPDATE;
      // this.preloader = true;
    }
  },
  methods: {
    submit() {
      if (this.modalTitle == "Edit") {
        this.preloader = true;
        axiosPost(actions.WORKSPACE_UPDATE, this.inputs)
          .then((res) => {
            
            this.$toastr.s(res.data.message);
          })
          .catch((error) => {
            
            this.$toastr.e(error);
          })
          .finally(() => {
            this.preloader = false;
            $("#demo-add-edit-Modal").modal("hide");
            this.$hub.$emit("reload-" + this.tableId);
          });
      } else {
      this.save(this.inputs);
      }
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      // if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data.workspace;
      this.inputs.select_users = response.data.select_users;
      this.inputs.select_companies = response.data.select_companies;
      this.preloader = false;
    },

    getUsers() {
      axiosGet(actions.GET_COMPANY_USERS)
          .then((res) => {
            this.users = res.data;
          })
          .catch((error) => {

          });
    },
    getCompanies() {
      axiosGet(actions.GET_COMPANIES)
          .then((res) => {
            this.companies = res.data;
          })
          .catch((error) => {

          });
    },
  },

  mounted() {
    this.getUsers();
    this.getCompanies();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
